import { colors } from '../../styles/theme';
import GuideLayout, { GuideStep } from './GuideLayout';

const vipSteps: GuideStep[] = [
  { id: 1, title: 'Uygulamaya Giriş', description: 'YolSepetiGO uygulamasını açın. Giriş yapın veya yeni hesap oluşturun.', image: '/images/customer-app/1.png' },
  { id: 2, title: 'VIP Taşıma Seçin', description: 'Ana ekranda "VIP Taşıma" hizmetine tıklayın. Mercedes Vito gibi VIP araçlarla transfer.', image: '/images/customer-app/2.png' },
  { id: 3, title: 'Güzergah Girin', description: 'Alış noktası ve varış noktasını (havaalanı, otel, adres) girin.', image: '/images/customer-app/3.png' },
  { id: 4, title: 'Yolcu & Araç', description: 'Yolcu sayısını, tarih/saat ve VIP araç tercihinizi belirtin.', image: '/images/customer-app/4.png' },
  { id: 5, title: 'Fiyatı Görün', description: 'Güzergah ve araç tipine göre özel fiyat teklifi görüntülenir. Onaylayın.', image: '/images/customer-app/5.png' },
  { id: 6, title: 'Eşleşme Bekleyin', description: 'Talebiniz gönderildi! Profesyonel VIP şoför yönlendirilir.', image: '/images/customer-app/6.png' },
  { id: 7, title: 'Ödeme Yapın', description: 'VISA, MasterCard veya Troy ile güvenli ödeme yapın.', image: '/images/customer-app/7.png' },
  { id: 8, title: 'Canlı Takip', description: 'VIP aracınızı ve şoförünüzü transfer boyunca haritada canlı takip edin.', image: '/images/customer-app/8.png' },
];

export default function VipTasimaGuidePage() {
  return (
    <GuideLayout
      service="vip-tasima"
      poster={{ src: '/images/services/vip-tasima.jpg', alt: 'VIP Taşıma hizmeti tanıtımı' }}
      seo={{
        title: 'VIP Taşıma Talebi Nasıl Oluşturulur?',
        description: 'YolSepetiGO ile Mercedes Vito gibi VIP araçlarla havaalanı transferi ve özel yolcu taşıma talebi nasıl oluşturulur? Adım adım rehber.',
        keywords: ['vip taşıma', 'vip transfer', 'mercedes vito', 'havaalanı transferi', 'özel yolcu taşıma'],
      }}
      breadcrumb="VIP Taşıma"
      title="VIP Taşıma Talebi Nasıl Oluşturulur?"
      subtitle="Mercedes Vito gibi VIP araçlarla havaalanı transferi ve özel yolcu taşıma hizmeti."
      accent={{
        from: colors.premium[600],
        to: colors.neutral[900],
        soft: colors.premium[50],
        border: colors.premium[200],
        strong: colors.premium[700],
        text: colors.premium[900],
      }}
      steps={vipSteps}
      tipsTitle="VIP Taşıma İpuçları"
      tips={[
        'Uçuş saatinizi paylaşın, şoförünüz sizi zamanında karşılasın.',
        'Yolcu sayısı ve bagaj durumunuza göre doğru VIP araç yönlendirilir.',
        'Havaalanı karşılamalarında buluşma noktanızı önceden belirtin.',
        'Özel günler ve kurumsal transferler için 7/24 destek hattımızı arayabilirsiniz.',
      ]}
      cta={{
        title: 'VIP Transferinizi Planlayın',
        text: 'Havaalanı transferi veya özel yolcu taşıma için VIP aracınızı hemen talep edin.',
        label: 'VIP Taşıma Talep Et',
        href: 'https://yolsepetigo.com',
        tone: 'premium',
      }}
    />
  );
}
